import React from "react";
import Navbar from './Components/navbar/navbar.component';
import MapSection from './Components/map/map.component';
import Footer from './Components/footer/footer.component';
// This line enables the BrowserRouter, Switch and Route Components, useful to render different HTML paths in React through components
import { Switch, Route} from 'react-router-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Signin from './Components/signin/signin.component';
import NavTabs from './pages/Tabpanel';
import DatabaseNew from './pages/DatabaseNew';
import './App.css';

function App() {

  
   

  return (
    <div className="App">
        <Switch>
          {/*senza navigation bar */}
          <Route path='/signin' component={Signin} />
        </Switch>
        <>
          <Navbar />
          <Route path='/mappa' exact render={props =>
            <div>
              <MapSection />
              <Footer />
            </div>
          } />
          <div> {/*added div for footer */}
          <Route exact path="/database" render={props => <DatabaseNew />} />
          <Route exact path="/tabpanel/:record_id" render={props =>
              <div>
                <NavTabs {...props} />
              </div>
            }>
             
            </Route>
            <footer /> 
              
            </div>
          {/*  <Route path="/document" component={Document} /> */}
        
        </>
    </div>
  );
}

export default App;
